import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameGeometry";
import useTopicQuestions from "../../hooks/useTopicQuestionsNew";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';

//NEW CSV STUFF
import Papa from "papaparse";
import extraquestions from '../../assets/Geometry/ExtraQuestions/geometry_extraquestions.csv';

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//used for smart allocation -refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

//Fail safe
var lastQuetionAnswer = "";

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}



export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const { loadedquestions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  //if question counter is higher than 3 then reset -refeed
   if(questionCounter > 3){
      questionCounter = 0;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  //Generates a question from a default question
  function GenQuestion(q) {
    console.log(q);
    //new question stuff
    if (q.task_code != undefined){

      let questionAnswers = [];
      questionAnswers.push({ correct: true, value: q.correct_answer });
      //Add the wrong answers
      questionAnswers.push({ correct: false, value: q.incorrect_answer_1 });
      questionAnswers.push({ correct: false, value: q.incorrect_answer_2 });
      questionAnswers.push({ correct: false, value: q.incorrect_answer_3 });

      shuffleArray(questionAnswers);

      let questionObj = {
        question: q.questionline1,
        image: q.value_for_images.replace(" ", "") + ".png",
        answers: questionAnswers,
        correct: q.correct_answer,
        topic_key: q.topic_key
      };
      setRefresh(!refresh)
      return questionObj;

    }else{
      //All the shared variables
      let questionAnswers = [];
      //Add the correct answer
      questionAnswers.push({ correct: true, value: q.right_answer });
      //Add the wrong answers
      questionAnswers.push({ correct: false, value: q.other_answer_1 });
      questionAnswers.push({ correct: false, value: q.other_answer_2 });
      questionAnswers.push({ correct: false, value: q.other_answer_3 });

      shuffleArray(questionAnswers);

      let questionObj = {
        question: q.question,
        image: q.image,
        answers: questionAnswers,
        correct: q.right_answer,
        topic_id: q.topic_id
      };
      setRefresh(!refresh)
      return questionObj;
    }
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    console.log(questions);
    currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
    console.log("CURRENT QUESTION:");
    console.log(currQuestion);

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
        */

        //get refeed question
        var loop = true;
        var failSafeCounter = 0;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else
        {
          //if current quesiton is same as the previous question then reloop -ref 
         while(loop){
            if (currQuestion.question.toString() === lastQuestion.toString()) { 
               // console.log("tst: I have looped!");
                currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 
                failSafeCounter = failSafeCounter + 1;
                if(failSafeCounter > 5){
                    if(currQuestion.correct.toString() === lastQuetionAnswer.toString()){
                        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 
					}
                    else{
                         lastQuestion = "";          
					}
				}
            }
            else{
             //  console.log("tst: Good to go!");
               loop = false; 
               break;
		    }
		 }   
        } 
        setCurrentQuestion(currQuestion)
        setRefresh(!refresh);
        CheckImage();
  }

  //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
  function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
    }

  function CheckImage() {
    if (currQuestion.image != "" && currQuestion.image != undefined) {
      console.log(currQuestion.image);
      var currImage = currQuestion.image;
      var correctAnswerName;
      //gets correct answer name for testing
      console.log(currQuestion);
      for (let i = 0; i < currQuestion.answers.length; i++) {
        if (currQuestion.answers[i].correct == true)
          correctAnswerName = currQuestion.answers[i].value;
      }
      //check if image is certain images then change it
      if (currQuestion.image == "grid2squares.jpg") {
        if (correctAnswerName == "4,3")
          currImage = "grid2squares43.jpg"
        else if (correctAnswerName == "2,5") {
          currImage = "grid2squares25.jpg";
        }
        else if (correctAnswerName == "5,2") {
          currImage = "grid2squares52.jpg";
        }
        else if (correctAnswerName == "1,5") {
          currImage = "grid2squares15.jpg";
        }
        else if (correctAnswerName == "5,5") {
          currImage = "grid2squares55.jpg";
        }
        else if (correctAnswerName == "5,4") {
          currImage = "grid2squares54.jpg";
        }
      }
      if (currQuestion.image == "firstquadgrid.jpg") {
        if (correctAnswerName == "2,3")
          currImage = "firstquadgrid23.jpg"
        else if (correctAnswerName == "5,1") {
          currImage = "firstquadgrid51.jpg";
        }
        else if (correctAnswerName == "1,5") {
          currImage = "firstquadgrid15.jpg";
        }
        else if (correctAnswerName == "2,5") {
          currImage = "firstquadgrid25.jpg";
        }
        else if (correctAnswerName == "4,2") {
          currImage = "firstquadgrid42.jpg";
        }
        else if (correctAnswerName == "1,3") {
          currImage = "firstquadgrid13.jpg";
        }
        else if (correctAnswerName == "5,5") {
          currImage = "firstquadgrid55.jpg";
        }
        else if (correctAnswerName == "5,1") {
          currImage = "firstquadgrid51.jpg";
        }
        else if (correctAnswerName == "3,5") {
          currImage = "firstquadgrid35.jpg";
        }
        else if (correctAnswerName == "5,2") {
          currImage = "firstquadgrid52.jpg";
        }
        else if (correctAnswerName == "4,3") {
          currImage = "firstquadgrid43.jpg";
        }
        else if (correctAnswerName == "2,5") {
          currImage = "firstquadgrid25.jpg";
        }
        else if (correctAnswerName == "5,4") {
          currImage = "firstquadgrid54.jpg";
        }

      }
      if (currQuestion.image == "Gridsquaremirror.jpg") {
        if (correctAnswerName == "(1,1)(2,1)(2,2)(1,2)") {
          currImage = "Gridsquaremirror11.jpg"
        }
        else if (correctAnswerName == "(2,2)(3,2)(3,3)(2,3)") {
          currImage = "Gridsquaremirror22.jpg"

        }
        else if (correctAnswerName == "(2,3)(3,3)(3,4)(2,4)") {
          currImage = "Gridsquaremirror23.jpg"
        }

        else if (correctAnswerName == "(2,0)(3,0)(3,1)(2,1)") {
          currImage = "Gridsquaremirror20.jpg"
        }

      }
      if (currQuestion.image == "Gridsquare.jpg") {
        if (correctAnswerName == "(4,2)(5,2)(5,3)(4,3)") {
          currImage = "Gridsquare42.jpg"
        }
        else if (correctAnswerName == "(2,2)(3,2)(3,3)(2,3)") {
          currImage = "Gridsquare22.jpg"
        }
        else if (correctAnswerName == "(5,0)(6,0)(6,1)(5,1)") {
          currImage = "Gridsquare50.jpg"
        }

      }
      if (currQuestion.image == "fullquadgrid.jpg") {
        if (correctAnswerName == "(4,3)") {
          currImage = "fullquadgrid43"
        }
        else if (correctAnswerName == "(2,-2)") {
          currImage = "fullquadgrid2-2"
        }
        else if (correctAnswerName == "(-4,4)") {
          currImage = "fullquadgrid-44"
        }
        else if (correctAnswerName == "(-4,-2)") {
          currImage = "fullquadgrid-4-2"
        }
        else if (correctAnswerName == "(-3,4)") {
          currImage = "fullquadgrid-34"
        }
        else if (correctAnswerName == "(-4,2)") {
          currImage = "fullquadgrid-42"
        }
        else if (correctAnswerName == "(-3,-3)") {
          currImage = "fullquadgrid-3-3"
        }
        else if (correctAnswerName == "(3,3)") {
          currImage = "fullquadgrid33"
        }
        else if (correctAnswerName == "(2,4)") {
          currImage = "fullquadgrid24"
        }
        else if (correctAnswerName == "(-2,4)") {
          currImage = "fullquadgrid-24"
        }
        else if (correctAnswerName == "(-2,-4)") {
          currImage = "fullquadgrid-2-4"
        }
        else if (correctAnswerName == "(1,1)") {
          currImage = "fullquadgrid11"
        }
        else if (correctAnswerName == "(-1,-1)") {
          currImage = "fullquadgrid-1-1"
        }
        else if (correctAnswerName == "(-1,-1)") {
          currImage = "fullquadgrid-1-1"
        }
        else if (correctAnswerName == "(-1,1)") {
          currImage = "fullquadgrid-11"
        }
        else if (correctAnswerName == "(-4,-1)") {
          currImage = "fullquadgrid-4-1"
        }
        else if (correctAnswerName == "(3,1)") {
          currImage = "fullquadgrid31"
        }
        else if (correctAnswerName == "(3,-2)") {
          currImage = "fullquadgrid3-2"
        }
        else if (correctAnswerName == "(-4,-4)") {
          currImage = "fullquadgrid-4-4"
        }
        else if (correctAnswerName == "(4,4)") {
          currImage = "fullquadgrid44"
        }
        else if (correctAnswerName == "(4,-4)") {
          currImage = "fullquadgrid4-4"
        }
        else if (correctAnswerName == "(-2,-2)") {
          currImage = "fullquadgrid-2-2"
        }
        else if (correctAnswerName == "(4,-1)") {
          currImage = "fullquadgrid4-1"
        }
        else {
          currImage = "fullquadgrid";
        }
        currImage += ".jpg";
      }
      if (currQuestion.image == "rectlongside.jpg") {
        if (correctAnswerName == "20") {
          currImage = "rectlongside20.jpg";
        }
        else if (correctAnswerName == "45") {
          currImage = "rectlongside45.jpg";
        }
        else if (correctAnswerName == "150") {
          currImage = "rectlongside150.jpg";
        }
        else if (correctAnswerName == "270") {
          currImage = "rectlongside270.jpg";
        }
        else if (correctAnswerName == "8") {
          currImage = "rectlongside8.jpg";
        }
      }
      if (currQuestion.image == "rectshortside.jpg") {
        if (correctAnswerName == "2") {
          currImage = "rectshortside2.jpg";
        }
        else if (correctAnswerName == "5") {
          currImage = "rectshortside5.jpg";
        }
        else if (correctAnswerName == "7") {
          currImage = "rectshortside7.jpg";
        }
        else if (correctAnswerName == "15") {
          currImage = "rectshortside15.jpg";
        }
        else if (correctAnswerName == "75") {
          currImage = "rectshortside75.jpg";
        }
      }


      var imagePath = currImage.replace(".jpg", ".png");
      console.log(imagePath)
      currQuestion.image = imagePath;
    }
  }

  //Called on click
  async function checkResult(value, callback) {

  //set the current question to the last question -refeed
    questionCounter = questionCounter +1;
    lastQuestion = currQuestion.question;
    lastQuetionAnswer = currQuestion.correct;

    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
            refeedQuestions.pop();
            repeating = false;
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
      };
      setNoFeedback([...nofeedback, result]);

        newQuestion();
      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
         //push question to refeed if user gets it wrong - refeed
          refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);

    return FilteredAnswers().map(answer => (

      <Button
        {...console.log(answer)}
        value={<div dangerouslySetInnerHTML={answer.value} />}
        style={{ flex: 1, margin: "20px" }}
        onClick={() => checkResult(answer, true)}
      >
        {answer.value.includes(".jpg") != true ? (
          <div style={{ height: "80%", width: "100%" }}>
            <Textfit mode="multi" max="99" style={{ height: "90%" }}>
              {answer.value}
            </Textfit>
          </div>
        ) : (
            <ButtonImage src={require("../../assets/Geometry/Shapes/" + answer.value.replace(".jpg", ".png"))} ></ButtonImage>
          )
        }
      </Button>
    ))

  }

  function MultipleFeedbackButtons() {
    console.log(currentQuestion);

    return FilteredAnswers().map(answer => (

      <Button
        {...console.log(answer)}
        value={<div dangerouslySetInnerHTML={answer.value} />}
        style={{ flex: 1, margin: "20px" , ...(answer.value == currQuestion.correct ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
      >
        {answer.value.includes(".jpg") != true ? (
          <div style={{ height: "80%", width: "100%" }}>
            <Textfit mode="multi" max="99" style={{ height: "90%" }}>
              {answer.value}
            </Textfit>
          </div>
        ) : (
            <ButtonImage src={require("../../assets/Geometry/Shapes/" + answer.value.replace(".jpg", ".png"))} ></ButtonImage>
          )
        }
      </Button>
    ))

  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if(waitTime != -10 ){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    console.log(questions);
    if (questions !== undefined && questions.length > 0) {
        console.log("Starting Game");
        newQuestion();
        //setCurrentQuestion(sample);
        CheckImage();
    }
  }, [questions]);

      function AddExtraQuestions(){
        console.log("Adding Extra Questions");
        console.log(extraquestions);
        //import from CSV
        Papa.parse(extraquestions, {
          download: true,
          header: true,
          complete: function (results) {
            let test = 123;
            console.log(test);
            console.log("PROPS");
            console.log(props);
            console.log("Extra Questions:");
            console.log(results.data)
            console.log(loadedquestions);
            console.log(status);
            let addMe = [];
            //check set topics and see if in extra questions
            console.log("Topics Selected:");
            console.log(props.topicKeys);
            for (let i = 0; i < props.topicKeys.length; i++) {
              const topicKey = props.topicKeys[i];
              console.log(topicKey);
              for (let x = 0; x < results.data.length; x++) {
                const extraQ = results.data[x];
                //console.log(extraQ);
                if (extraQ.topic_key == topicKey){
                  console.log("found you")
                  addMe.push(extraQ);
                }
              }
            }
    
            if (loadedquestions != null){
              //if already loaded
              console.log("add loaded questions");
              for (let i = 0; i < loadedquestions.length; i++) {
                const loadedquesiton = loadedquestions[i];
                addMe.push(loadedquesiton);
              }
          }
            console.log("ALLQUESTIONS:");
            console.log(addMe);
            setQuestions(addMe);
            console.log("done adding extra questions");
          },
        });
      }

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
      AddExtraQuestions();
    }
  }, [status]);

  function FilteredAnswers() {
    if (currentQuestion.answers != undefined) {
      return currentQuestion.answers.filter(v => v.value !== "");
    }
    return currentQuestion;
  }

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/"+imageName)

        return (require("../../assets/"+imageName))

}

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() => {
        props.onBack();
        Reset();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={1720}>
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Question
                        type="text"
                        disabled
                        value={
                          currentQuestion.question !== undefined
                            ? currentQuestion.question.replace("$", "?")
                            : ""
                        }
                      ><Textfit mode="single" style={{ height: "100%" }}>

                          {currQuestion.question}
                        </Textfit>
                      </Question>
                    </div>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "center" }}>
                      {currentQuestion.image != "" && currentQuestion.image != undefined ? (
                        <img style={{maxHeight: "250px"}}
                          src={require('../../assets/Geometry/Shapes/' + currQuestion.image)}>
                        </img>
                      ) : (
                          <div></div>
                        )}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                      }}
                    >
                      {showColouredFeedback == false && currQuestion.answers !== undefined &&
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {MultipleButtons()}
                        </div>}

                        {showColouredFeedback == true && currQuestion.answers !== undefined &&
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {MultipleFeedbackButtons()}
                        </div>}
                    </div>
                  </Container>

                ) : <h1>blank</h1>}
              </div>
              <Combo>
                <span style={{ fontSize: "50px" }}>{combo}</span>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`